import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

/**
 * Component that redirects based on authentication status
 * - If user is not authenticated, redirects to login
 * - If user is authenticated as admin, redirects to admin dashboard
 * - If user is authenticated as regular user, redirects to user dashboard
 */
const AuthRedirect = ({ loginPath, userPath, adminPath }) => {
  const { isAuthenticated, currentUser } = useContext(AuthContext);

  if (!isAuthenticated) {
    return <Navigate to={loginPath} replace />;
  }

  if (currentUser?.role === 'admin') {
    return <Navigate to={adminPath} replace />;
  }

  return <Navigate to={userPath} replace />;
};

export default AuthRedirect;